import { useMemo } from 'react';
import gettext from '@sdk/lang/gettext';
import { PersonaPickerOption } from '@sdk/components/forms/personaPickers/PersonaPicker/personaPicker.types';

import { useGetUserIdsByWorkDay } from '@web/common/utils/useGetUserIdsByWorkDay';

import {
  createWorkByDatePersonaOption,
  getWorkDayDates,
} from './useWorkingByDayPersonaOption.utils';

export const useWorkingByDayPersonaOption = () => {
  const workingTodayGroupId = -1;
  const workingTomorrowGroupId = -2;
  const { today, tomorrow } = getWorkDayDates();
  const { data: workingToday = [] } = useGetUserIdsByWorkDay(today);
  const { data: workingTomorrow = [] } = useGetUserIdsByWorkDay(tomorrow);

  const { workingTodayGroup, workingTomorrowGroup } = useMemo(() => {
    const workingTodayGroup =
      workingToday.length > 0 &&
      createWorkByDatePersonaOption(
        workingTodayGroupId,
        workingToday,
        gettext('Everyone working today')
      );
    const workingTomorrowGroup =
      workingTomorrow.length > 0 &&
      createWorkByDatePersonaOption(
        workingTomorrowGroupId,
        workingTomorrow,
        gettext('Everyone working tomorrow')
      );

    return {
      workingTodayGroup,
      workingTomorrowGroup,
    };
  }, [workingToday, workingTodayGroupId, workingTomorrow, workingTomorrowGroupId]);

  const possiblyUnwrapOption = (option: PersonaPickerOption) => {
    if (option.id === workingTodayGroupId) {
      return workingToday.map((id) => ({ id }));
    }

    if (option.id === workingTomorrowGroupId) {
      return workingTomorrow.map((id) => ({ id }));
    }

    return option;
  };

  return {
    possiblyUnwrapOption,
    workingTomorrow,
    workingTomorrowGroup,
    workingTomorrowGroupId,
    workingToday,
    workingTodayGroup,
    workingTodayGroupId,
  };
};
